import DialogBox from '@mummssoftware/common-ui/Dialog';
import React from 'react';
import styled from 'styled-components';
import defaults from '../../translations/en.json';

const translations: NonNullable<mumms.JSONObject> = defaults;

const FormsSaveWarningMessageContainer = styled.div`
  background-color: ${(props) => props.theme.palette.background.paper};
  margin: auto;
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  ${(props) => props.theme.breakpoints.down('xs')} {
    && {
      font-size: 0.9em;
      width: 80%;
    }
  }
`;

const FormsSaveWarningTitleContainer = styled.div`
  background-color: rgb(46, 46, 46);
  padding: 1em;
  border: solid 1px white;
  border-bottom: none;
  ${(props) => props.theme.breakpoints.down('xs')} {
    && {
      padding: 10px 5px 10px 10px;
      background-color: rgb(46, 46, 46);
    }
  }
`;

const FormsSaveWarningTextContainer = styled.div`
  padding: 1em;
  border: 1px solid white;
  border-top: none;
  ${(props) => props.theme.breakpoints.down('xs')} {
    && {
      padding: 5px 10px 10px 10px;
      border-radius: 1px solid black;
      border: 1px solid white;
      border-top: none;
    }
  }
`;

const showSubmissionWarningList = () => (
  <ul>
    <li>{translations.formSubmissionWarningList_browser}</li>
    <li>{translations.formSubmissionWarningList_page}</li>
    <li>{translations.formSubmissionWarningList_tab}</li>
    <li>{translations.formSubmissionWarningList_nav}</li>
    <li>{translations.formSubmissionWarningList_lid}</li>
    <li>{translations.formSubmissionWarningList_mobile}</li>
  </ul>
);

export const showSaveWarning = () => (
  <FormsSaveWarningMessageContainer>
    <FormsSaveWarningTitleContainer>
      <h3>{translations.formSubmissionWarningTitle}</h3>
    </FormsSaveWarningTitleContainer>
    <FormsSaveWarningTextContainer>
      <p>{translations.formSubmissionWarningMsg}</p>
      {showSubmissionWarningList()}
    </FormsSaveWarningTextContainer>
  </FormsSaveWarningMessageContainer>
);

export const showSaveWarningDialog = (
  isNavigating: boolean,
  handleModleClose: () => void,
) => (
  <DialogBox
    title={translations.formSubmissionWarningTitle as string}
    disableBackdropClick
    open={isNavigating}
    handleClick={handleModleClose}
  >
    <p>
      {' '}
      {`${translations.formsSubmissionWarningDialogOnlyMessage} ${translations.formSubmissionWarningMsg}`}
    </p>
    {showSubmissionWarningList()}
  </DialogBox>
);
